import { STEP_WEIGHT } from '../../../../../organisms/AccountActivation/account-activation.constants';

/**
 * Calculates the number of completed steps based on activation state and email verification status.
 *
 * The logic starts with totalSteps or totalSteps-1 based on email verification,
 * then subtracts the weight of each activation state that still needs to be completed.
 *
 * @param activationState - Array of required activation states that still need to be completed
 * @param isEmailVerified - Whether the user's email is verified
 * @param totalSteps - Total number of steps (4 or 5 depending on region/settings)
 * @returns The number of completed steps. Returns 2 if email verified and no activation state,
 *          returns 1 if email not verified and no activation state, otherwise calculates based on weights.
 */
export const calculateCompletedSteps = (
  activationState: string[] | null | undefined,
  isEmailVerified: boolean,
  totalSteps: number,
): number => {
  if (!activationState) {
    return isEmailVerified ? 2 : 1;
  }

  return Math.trunc(
    activationState.reduce(
      (accumulator, state) => {
        return (
          accumulator - (STEP_WEIGHT[state as keyof typeof STEP_WEIGHT] || 0)
        );
      },
      isEmailVerified ? totalSteps : totalSteps - 1,
    ) || 1,
  );
};
